import { render, staticRenderFns } from "./Browser_warning modal.vue?vue&type=template&id=30c03f8c&scoped=true&"
import script from "./Browser_warning modal.vue?vue&type=script&lang=ts&"
export * from "./Browser_warning modal.vue?vue&type=script&lang=ts&"
import style0 from "./Browser_warning modal.vue?vue&type=style&index=0&id=30c03f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c03f8c",
  null
  
)

export default component.exports